module.exports = __webpack_public_path__ + "static/hero-bg.2e1554cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-bg.png
// module id = 428
// module chunks = 35783957827783